import React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import AdminLayout from '../../../layouts/AdminLayout';
import { ZipFileExplorer } from '../../../components/ZipFileExplorer';

const useStyles = makeStyles(() => ({
  body: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    minHeight: '50vh',
    left: 0,
    top: 0
  }
}));

const Files = (props: RouteComponentProps<{file_id: string}>) => {
  const { file_id } = props.match.params;
  const classes = useStyles();

  return (
    <AdminLayout maxWidth={false} className="flex-fill position-relative">
      <div className={classes.body}>
        <ZipFileExplorer fileId={file_id} />
      </div>
    </AdminLayout>
  );
};

export default Files;
